<template>
  <div>
    <el-form>
      <el-form-item :label="label" required>
        <el-input v-model="value"> </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: () => ''
    },
    searchHandle: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  mounted () {
    console.log('value', this.value)
  },
  watch: {},
  computed: {},
  methods: {
    // 重置表单
    reset () {
      this.$refs.FormData.resetFields()
      this.$refs.FormData.clearValidate()
      console.log('重置表单')
    }
  }
}
</script>
<style scoped></style>
